import React, { useContext } from 'react';
import ScreenTextContext from '../../contexts/ScreenTextContext';
import { TaskMarkers, TaskResultCount } from '../';
import { MODES } from '../../utils/constants';

export const TeamScore = ({active, currentRoundIndex, index, mode, score, team, viewingFeedback}) => {

  const { screenText } = useContext(ScreenTextContext);  


  if (!screenText || !screenText.setUp ) {
    return ''; // Should return error? Loading?
  }
  
  const { teamNames : teamsText } = screenText.global;

  return (
    <div className={`team-score team-score--${index}${active ? ' team-score--active' : ''}`}>
      <div className="team-score__logo">
        <img src={`${process.env.PUBLIC_URL}/assets/images/teams-sm/${team + (active ? '-active' : '')}.png`} alt="" aria-labelledby={"team-" + index} />
      </div>

      <div className="team-score__details">

        <div className="team-score__name" id={"team-" + index}>{teamsText[team].label}</div>
    
        {
          score.map((round, i) => (
            mode === MODES.LECTURE ? 
              // UI assumes only one round for lecture mode
              // Coded to be more flexible, just in case
              <TaskResultCount 
                key={i}
                roundScore={score[i]}
              />
            :
              <TaskMarkers round={round}
                key={i}
                active={active}
                currentRoundIndex={currentRoundIndex}
                roundIndex={i}
                viewingFeedback={viewingFeedback}
              />
          ))
        }

      </div>

    </div>
  )
}